export default __webpack_public_path__ + "static/media/logo-mark.288db7e2.svg";